import Vue from 'vue';
import ediOrderTransformer from './../../transformers/ediOrder';
import store from './../../store';

const success = (data, resolve) => {
  store.dispatch('fetchCurrentEdiOrder', ediOrderTransformer.fetch(data));
  resolve(data);
};

export default (id, ediOrder) => (
  new Promise((resolve, reject) => {
    let url = `edi_orders/${id}/confirm`;

    if (localStorage.getItem('is_admin')) {
      url = `edi_orders/${id}/confirm?is_admin=true`;
    }

    Vue.$http
      .post(url, ediOrder)
      .then((response) => {
        success(response.data, resolve);
      })
      .catch((error) => {
        reject(error.response);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/ediOrder/confirm.js